export default __webpack_public_path__ + "static/media/welcome-female@3x.fabed1fb.png";